import { useState } from 'react';
import supabase from './supabase';

function Auth({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    if (isSignUp) {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) {
        setError(error.message);
      } else {
        setMessage('Account created! You can now log in.');
        setIsSignUp(false);
      }
    } else {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        setError(error.message);
      } else {
        onLogin(data.user);
      }
    }

    setLoading(false);
  };

  return (
    <div className="app">
      <header className="header">
        <h1>🌿 What Is This Plant?</h1>
        <p className="tagline">Identify any plant instantly</p>
      </header>

      <main className="main">
        <div className="auth-card">
          <h2>{isSignUp ? 'Create Account' : 'Welcome Back'}</h2>
          <p className="auth-subtitle">
            {isSignUp ? 'Sign up for free — 3 identifications included' : 'Log in to your account'}
          </p>

          <form onSubmit={handleSubmit} className="auth-form">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="auth-input"
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="auth-input"
              required
            />
            <button type="submit" className="identify-btn" disabled={loading}>
              {loading ? 'Please wait...' : isSignUp ? 'Create Account' : 'Log In'}
            </button>
          </form>

          {error && <div className="error">{error}</div>}
          {message && <div className="success">{message}</div>}

          <p className="auth-switch">
            {isSignUp ? 'Already have an account?' : "Don't have an account?"}
            <button className="auth-link" onClick={() => { setIsSignUp(!isSignUp); setError(null); }}>
              {isSignUp ? ' Log in' : ' Sign up'}
            </button>
          </p>
        </div>
      </main>
    </div>
  );
}

export default Auth;
